export const AUTH_USER = "auth_user";
export const SHOW_SNACKBAR = "show_snackbar";
export const HIDE_SNACKBAR = "hide_snackbar";
export const PREFERENCES = "PREFERENCES";
export const ADD_FAVORITE = "add_favorite";
export const DEL_FAVORITE = "del_favorite";

